var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSDevicesIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "S_Devices_Icon",
    "data-name": "S Devices Icon",
    xmlns: "http://www.w3.org/2000/svg",
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_32908",
    "data-name": "Rectangle 32908",
    width: 60,
    height: 60,
    fill: "none",
    opacity: 0
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_40663",
    "data-name": "Path 40663",
    d: "M16.594,20.8H3.017A3.112,3.112,0,0,1,0,17.6V3.2A3.112,3.112,0,0,1,3.017,0H16.594a3.112,3.112,0,0,1,3.017,3.2V17.6a3.112,3.112,0,0,1-3.017,3.2M48,17.6V3.2A3.112,3.112,0,0,0,44.983,0H31.406a3.113,3.113,0,0,0-3.017,3.2V17.6a3.113,3.113,0,0,0,3.017,3.2H44.983A3.112,3.112,0,0,0,48,17.6m0,27.2V30.4a3.112,3.112,0,0,0-3.017-3.2H31.406a3.113,3.113,0,0,0-3.017,3.2V44.8A3.113,3.113,0,0,0,31.406,48H44.983A3.112,3.112,0,0,0,48,44.8m-28.389,0V30.4a3.112,3.112,0,0,0-3.017-3.2H3.017A3.112,3.112,0,0,0,0,30.4V44.8A3.112,3.112,0,0,0,3.017,48H16.594a3.112,3.112,0,0,0,3.017-3.2",
    transform: "translate(6 6)",
    fill: "#3c3c3b"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSDevicesIcon);
export default __webpack_public_path__ + "static/media/S Devices Icon.6dcd9b591c2cb1c645c48be96c27d99f.svg";
export { ForwardRef as ReactComponent };